import axios from 'axios'

function montarPayloadDevolucao(data) {
  const camposDevolucao = [
    'ID',
    'FORNECEDOR_ID',
    'DESTINATARIO_ID',
    'VENDA_ID',
    'DATA_VENDA',
    'VALOR_VENDA',
    'VALOR_DEVOLUCAO_NFE',
    'VALOR_REPROCESSADO',
    'STATUS',
    'OP_TIPO_MOVIMENTO',
    'OP_XML',
    'OP_CONFIRMAR_NFE',
    'OP_SOLICITA_RECEPCAO',
    'OP_RECEPCAO',
    'OP_NFE_PROPRIA',
    'CENTRO_ESTOQUE_ID',
    'CHAVE_ACESSO_NFE_DEVOLVIDA',
    'OBSERVACAO_DEVOLUCAO',
    'USUARIO_ALTERACAO',
    'itens'
  ]
  const payload = camposDevolucao.reduce((acc, campo) => {
    if (data && Object.prototype.hasOwnProperty.call(data, campo)) acc[campo] = data[campo]
    return acc
  }, {})

  payload.itens = (payload.itens || []).map(item => ({
    ID: item.ID,
    QUANT_DEVOLVIDO_NFE: item.QUANT_DEVOLVIDO_NFE,
    PECAS_DEVOLVIDO_NFE: item.PECAS_DEVOLVIDO_NFE,
    VL_UNT_DEVOLVIDO: item.VL_UNT_DEVOLVIDO
  }))

  return payload
}

const state = {
  devolucoes: [],
  devolucao: {
    ID: null,
    FORNECEDOR_ID: null,
    DESTINATARIO_ID: null,
    CLIENTE_NOME: '',
    VENDA_ID: null,
    DATA_VENDA: null,
    VALOR_VENDA: 0,
    VALOR_DEVOLUCAO_NFE: 0,
    VALOR_REPROCESSADO: 0,
    STATUS: '1',
    OP_TIPO_MOVIMENTO: '3',
    OP_XML: '0',
    OP_CONFIRMAR_NFE: '0',
    OP_SOLICITA_RECEPCAO: '0',
    OP_RECEPCAO: '0',
    OP_NFE_PROPRIA: '0',
    OP_FINANCEIRO_ATUALIZADO: '0',
    VALOR_FINANCEIRO_DESCONTO: 0,
    CENTRO_ESTOQUE_ID: null,
    itens: []
  }
}

const mutations = {
  SET_DEVOLUCOES(state, data) {
    state.devolucoes = data
  },
  SET_DEVOLUCAO(state, data) {
    state.devolucao = data
  },
  LIMPAR_DEVOLUCAO(state) {
    state.devolucao = {
      ID: null,
      FORNECEDOR_ID: null,
      DESTINATARIO_ID: null,
      CLIENTE_NOME: '',
      VENDA_ID: null,
      DATA_VENDA: null,
      VALOR_VENDA: 0,
      VALOR_DEVOLUCAO_NFE: 0,
      VALOR_REPROCESSADO: 0,
      STATUS: '1',
      OP_TIPO_MOVIMENTO: '3',
      OP_XML: '0',
      OP_CONFIRMAR_NFE: '0',
      OP_SOLICITA_RECEPCAO: '0',
      OP_RECEPCAO: '0',
      OP_NFE_PROPRIA: '0',
      OP_FINANCEIRO_ATUALIZADO: '0',
      VALOR_FINANCEIRO_DESCONTO: 0,
      CENTRO_ESTOQUE_ID: null,
      itens: []
    }
  }
}

const actions = {
  pesquisarDevolucoes({ commit }, filtros) {
    return axios.post('/api/protected/devolucao/pesquisar', filtros)
      .then(res => {
        commit('SET_DEVOLUCOES', res.data)
        return res.data
      })
  },
  getDevolucaoById({ commit }, id) {
    return axios.get(`/api/protected/devolucao/getById/${id}`)
      .then(res => {
        commit('SET_DEVOLUCAO', res.data)
        return res.data
      })
  },
  salvarDevolucao({ commit }, data) {
    return axios.post('/api/protected/devolucao/salvar', montarPayloadDevolucao(data))
      .then(res => res.data)
  },
  vincularPreFatura({ commit }, data) {
    return axios.post('/api/protected/devolucao/vincularPreFatura', data)
      .then(res => res.data)
  },
  pesquisarVendas({ commit }, filtros) {
    return axios.post('/api/protected/devolucao/pesquisarVendas', filtros)
      .then(res => res.data)
  },
  manifestar({ commit }, payload) {
    return axios.post('/api/protected/devolucao/manifestar', payload)
      .then(res => res.data)
  },
  darCiencia({ commit }, payload) {
    return axios.post('/api/protected/devolucao/darCiencia', payload)
      .then(res => res.data)
  },
  baixarPorChave({ commit }, payload) {
    return axios.post('/api/protected/devolucao/baixarPorChave', payload)
      .then(res => res.data)
  },
  baixarXml({ commit }, payload) {
    return axios.post('/api/protected/devolucao/baixarXml', payload)
      .then(res => res.data)
  },
  conciliarXml({ commit }, payload) {
    return axios.post('/api/protected/devolucao/conciliarXml', payload)
      .then(res => res.data)
  },
  desvincularXml({ commit }, payload) {
    return axios.post('/api/protected/devolucao/desvincularXml', payload)
      .then(res => res.data)
  },
  validarDecisaoFiscal({ commit }, payload) {
    return axios.post('/api/protected/devolucao/validarDecisaoFiscal', payload)
      .then(res => res.data)
  },
  diagnosticarDevolucao({ commit }, payload) {
    return axios.post('/api/protected/nfeMotor/diagnosticarDevolucao', payload)
      .then(res => res.data)
  },
  prepararDevolucao({ commit }, payload) {
    return axios.post('/api/protected/nfeMotor/prepararDevolucao', payload)
      .then(res => res.data)
  },
  recalcularDevolucao({ commit }, { nfeId, ...payload }) {
    return axios.post(`/api/protected/nfeMotor/recalcularDevolucao/${nfeId}`, payload)
      .then(res => res.data)
  },
  gerarNfePropria({ commit }, payload) {
    return axios.post('/api/protected/devolucao/gerarNfePropria', payload)
      .then(res => res.data)
  },
  validarFinalizacao({ commit }, payload) {
    return axios.post('/api/protected/devolucao/validarFinalizacao', payload)
      .then(res => res.data)
  },
  finalizar({ commit }, payload) {
    return axios.post('/api/protected/devolucao/finalizar', payload)
      .then(res => res.data)
  },
  atualizarFinanceiro({ commit }, payload) {
    return axios.post('/api/protected/devolucao/atualizarFinanceiro', payload)
      .then(res => res.data)
  },
  solicitarConferencia({ commit }, payload) {
    return axios.post('/api/protected/devolucao/solicitarConferencia', payload)
      .then(res => res.data)
  },
  cancelarSolicitacaoConferencia({ commit }, payload) {
    return axios.post('/api/protected/devolucao/cancelarSolicitacaoConferencia', payload)
      .then(res => res.data)
  },
  cancelarDevolucao({ commit }, payload) {
    return axios.post('/api/protected/devolucao/cancelar', payload)
      .then(res => res.data)
  },
  devolverTerminalConferencia({ commit }, payload) {
    return axios.post('/api/protected/devolucao/conferencia/devolver-terminal', payload)
      .then(res => res.data)
  },
  listarNfeDistribuicao({ commit }, payload) {
    return axios.post('/api/protected/devolucao/listarNfeDistribuicao', payload)
      .then(res => res.data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/devolucao-store.js